import styled from 'styled-components';

export const DescriptionWrapper = styled.div(
    props => `
        background-color: rgb(255, 255, 255);
        box-shadow: rgba(0, 0, 0, 0.25) 0px 0.1rem 0.4rem 0px;
        border-radius: 0.6rem;
        padding: 3rem 2rem;
        width: 100%;
        margin-bottom: 4rem;
        h2 {
            font-size: 2.2rem;
            color: rgb(20, 24, 35);
            font-family: ${props.theme.font.fontFamily};
            font-weight: 600;
            padding-bottom: 1.5rem;
        }
        p {
            padding-bottom: 2rem;
        }
`);